<template>
  <div
    :class="`as-standing as-parent-standing as-parent-standing-${gSiteName}`"
  >
    <div v-if="league" class="as-standing__league-info">
      <div class="as-league_title">
        <img
          class="as-lazyload"
          :src="getImgUrlBySport('competition', league.id)"
        />{{ getCompetitionNameShow(league) }}
      </div>
      <DropdownToggle
        :data="league.seasons"
        :idActive="league.cur_season_id"
        @handleChoose="changeSeason"
      />
    </div>
    <template v-if="standing && tables.length">
      <div
        class="as-standing__top"
        :class="{
          'as-standing__tabs-center': isPopup,
        }"
      >
        <TabsBtn :tabs="tabs" :activeTab="activeTab" @change="changeTab" />
        <div
          class="as-menu"
          :class="{
            'as-active': isShowFull,
          }"
          @click="handleShowFull"
        >
          <IconMenu />
        </div>
      </div>

      <div
        :class="{
          'as-show-full': isShowFull,
          'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
            isPopup,
        }"
      >
        <div v-for="(table, key) in tables" :key="key" class="as-standing__table">
          <div class="as-standing__table-row as-standing__table-row-head">
            <div
              v-for="column in columns"
              :key="column.name"
              @click="sortData(column.name)"
              :class="`as-standing__table-column ${column.class}`"
              type="button"
            >
              {{
                column.name === "team_name" ? getGroupName(table) : column.title
              }}

              <IconArrownDown
                v-if="sort.column === column.name"
                class="as-d-inline-flex"
                :class="{
                  'as-sort-down': sort.type === 'ASC',
                  'as-sort-up': sort.type === 'DESC',
                }"
              />
            </div>
            <div
              class="as-standing__table-column as-column-performance as-text-center as-coulumn-show-full"
            >
              Phong độ
              <IconArrowRight />
            </div>
            <div
              class="as-standing__table-column as-column-next as-scroll-item-active as-justify-content-center as-coulumn-show-full"
            >
              Tiếp
            </div>
          </div>
          <div
            v-for="(row, keyRow) in getRows(table.rows)"
            :key="keyRow"
            class="as-standing__table-row"
            :class="{
              active:
                match?.home_team_id === row.team_id ||
                match?.away_team_id === row.team_id,
            }"
          >
            <div
              class="as-standing__table-column as-standing__table-column-stt as-text-center"
              :class="{
                'as-stt-popup': isPopup,
              }"
            >
              <div class="as-stt" :style="getStyleStt(row.promotion_id)">
                {{ row.position }}
              </div>
            </div>
            <div
              class="as-standing__table-column as-standing__table-column-team"
              :class="{
                'as-team-popup': isPopup,
              }"
            >
              <div
                @click="getLinkTeamDetail(row.team_id, row.team_name, true)"
                class="as-match__team-group"
                :class="{
                  'as-match__team-group-live': row.live_score
                }"
              >
                <div class="as-match__team">
                  <img
                    :src="getImgUrlBySport('team', row.team_id)"
                    class="as-match__team-logo"
                    :alt="row.team_name"
                  />
                  <span class="as-standing__table-text">{{ row.team_name }}</span>
                </div>
                <StandingLiveScore v-if="row.live_score" :standing="row" />
              </div>
            </div>
            <div class="as-standing__table-column as-justify-content-center">
              {{ getRowdata(row, "total") }}
            </div>
            <div class="as-standing__table-column as-justify-content-center">
              {{ getRowdata(row, "won") }}
            </div>
            <div class="as-standing__table-column as-justify-content-center">
              {{ getRowdata(row, "draw") }}
            </div>
            <div class="as-standing__table-column as-justify-content-center">
              {{ getRowdata(row, "loss") }}
            </div>
            <div
              class="as-standing__table-column as-justify-content-center as-coulumn-show-full"
            >
              {{ getRowdata(row, "goals") }}:{{
                getRowdata(row, "goals_against")
              }}
            </div>
            <div
              class="as-standing__table-column as-justify-content-center as-coulumn-show-full"
            >
              {{ getRowdata(row, "goal_diff") }}
            </div>
            <div class="as-standing__table-column as-justify-content-center">
              {{ getRowdata(row, "points") }}
            </div>
            <div
              class="as-standing__table-column as-justify-content-center as-coulumn-show-full"
            >
              <div class="as-standing-tag__list">
                <button
                  v-for="(recent, keyRecent) in getRecent(row)"
                  :key="keyRecent"
                  :class="`as-standing-tag as-standing-tag__${determineMatchResult(
                    recent,
                    row.team_id
                  ).charAt(0)}`"
                  :title="getRecentTitle(recent)"
                >
                  {{ determineMatchResult(recent, row.team_id).charAt(0) }}
                </button>
              </div>
            </div>
            <div
              class="as-standing__table-column as-justify-content-center as-coulumn-show-full"
            >
              <img
                v-if="row.next_match"
                @click="
                  showTeamInfo(
                    row.next_match.away_team.id === row.team_id
                      ? row.next_match.home_team.id
                      : row.next_match.away_team.id
                  )
                "
                :src="
                  getImgUrlBySport(
                    'team',
                    row.next_match.away_team.id === row.team_id
                      ? row.next_match.home_team.id
                      : row.next_match.away_team.id
                  )
                "
                class="as-match__team-logo as-cursor-pointer"
                :alt="
                  row.next_match.away_team.id === row.team_id
                    ? row.next_match.home_team.name
                    : row.next_match.away_team.name
                "
                :title="
                  row.next_match.away_team.id === row.team_id
                    ? row.next_match.home_team.name
                    : row.next_match.away_team.name
                "
              />
            </div>
          </div>
        </div>

        <div v-if="promotions && promotions.length" class="as-promotion">
          <div
            v-for="(promotion, key) in promotions"
            :key="key"
            class="as-promotion-item"
          >
            <div
              class="as-promotion-circle"
              :style="{
                background: promotion.color,
              }"
            ></div>
            {{ promotion.name }}
          </div>
        </div>
      </div>
    </template>
    <NoData v-else />
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed, onMounted, nextTick } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import NoData from "~src/components/NoData.vue";
import DropdownToggle from "~src/components/DropdownToggle.vue";
import type {
  IStanding,
  IMatch,
  ILeague,
  ISeason,
  IStandingsRow,
  IStandingsTable,
  IPromotion,
  IRecent,
} from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  determineMatchResult,
  getCompetitionNameShow,
  getTeamName,
  getCupStage,
} from "~src/helpers";
import IconArrowRight from "../icons/IconArrowRight.vue";
import StandingLiveScore from "~src/components/standings/StandingLiveScore.vue";

const emits = defineEmits([
  "changeSeason"
]);

interface IProps {
  standing: IStanding;
  match?: IMatch;
  league?: ILeague;
  isPopup: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isPopup: true,
});

const isShowFull = ref(false);
const activeTab = ref("all");

const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: "Sân nhà",
    key: "home",
  },
  {
    title: "Sân khách",
    key: "away",
  },
]);

const columns = [
  {
    title: "#",
    name: "position",
    class: "as-justify-content-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Đội bóng",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head as-text-left",
  },
  {
    title: "Trận",
    name: "total",
    class: "as-justify-content-center as-c-total",
  },
  {
    title: "W",
    name: "won",
    class: "as-justify-content-center as-c-w",
  },
  {
    title: "D",
    name: "draw",
    class: "as-justify-content-center as-c-d",
  },
  {
    title: "L",
    name: "loss",
    class: "as-justify-content-center as-c-l",
  },
  {
    title: "G",
    name: "goals",
    class: "as-justify-content-center as-c-g as-coulumn-show-full",
  },
  {
    title: "HSBT",
    name: "goal_diff",
    class: "as-justify-content-center as-c-hsbt as-coulumn-show-full",
  },
  {
    title: "Điểm",
    name: "points",
    class: "as-justify-content-center as-c-point",
  },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const promotions = computed(() => {
  return props.standing.standings.promotions;
});

const tables = computed(() => {
  if (!props.standing?.standings) {
    return [];
  }

  const datas = [];
  for (const table of props.standing.standings.tables) {
    const rows = [];
    for (const row of table.rows) {
      rows.push({
        ...row,
        team_name: getTeamName(props.standing.teams, row.team_id),
      });
    }
    datas.push({
      ...table,
      rows,
    });
  }

  return datas;
});

const body = ref<HTMLDivElement | null>(null);

onMounted(async () => {
  await nextTick();
  body.value = document.querySelector(".as-parent-standing");
});

const scrollToActiveItem = (container: HTMLDivElement, activeItem: HTMLDivElement) => {
  try {
    if (!container || !activeItem) return;

    const containerRect = container.getBoundingClientRect();
    const activeItemRect = activeItem.getBoundingClientRect();

    const scrollLeft = container.scrollLeft + activeItemRect.left - containerRect.left;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  } catch (error) {
    console.error('Error in scrollToActiveItem:', error);
  }
}

const handleShowFull = async () => {
  isShowFull.value = !isShowFull.value;
  await nextTick();

  if (isShowFull.value && body.value) {
    const _tables = body.value.querySelectorAll<HTMLDivElement>(".as-standing__table") ?? [];
    if (!_tables?.length) return;

    Array.from(_tables).forEach((table) => {
      try {
        const activeItem = table.querySelector<HTMLDivElement>(".as-scroll-item-active");
        if (!activeItem) return;

        requestAnimationFrame(() => {
          setTimeout(() => {
            scrollToActiveItem(table as HTMLDivElement, activeItem);
          }, 100);
        });
      } catch (error) {
        console.error('Error scrolling to active item:', error);
      }
    });
  }
};

const changeTab = (val: string) => {
  activeTab.value = val;
};

const changeSeason = (season: ISeason) => {
  emits("changeSeason", season.id);
};

const getRows = (rows: Array<IStandingsRow>) => {
  return rows?.sort((a: any, b: any) => {
    if (activeTab.value === "all") {
      // chọn sắp xếp
      if (sort.value.column) {
        // sắp xếp string
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return a[sort.value.column] - b[sort.value.column];
          } else {
            return b[sort.value.column] - a[sort.value.column];
          }
        }
      } else {
        return a.position - b.position;
      }
    } else {
      if (sort.value.column) {
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return (
          a[`${activeTab.value}_position`] - b[`${activeTab.value}_position`]
        );
      }
    }
  });
};

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const getStyleStt = (promotion_id: string) => {
  const promotion = props.standing.standings.promotions.find(
    (item: IPromotion) => item.id == promotion_id
  );

  if (promotion) {
    return {
      backgroundColor: promotion.color,
      color: getContrastColor(promotion.color),
      fontWeight: 700,
    };
  }

  return {};
};

const getGroupName = (table: IStandingsTable) => {
  if (!table.stage || tables.value.length === 1) {
    return "Đội bóng";
  }

  const match = {
    stage: table.stage,
    round: {
      group_num: table.group,
      round_num: 0,
      stage_id: table.stage_id,
    },
  } as IMatch;
  const stageName = getCupStage(match);

  return stageName ? stageName : "Đội bóng";
};

const getRowdata = (row: IStandingsRow, field: string) => {
  if (field === "total") {
    if (activeTab.value === "all") {
      return row.total;
    } else if (activeTab.value === "home") {
      return row.home_total;
    } else {
      return row.away_total;
    }
  } else if (field === "won") {
    if (activeTab.value === "all") {
      return row.won;
    } else if (activeTab.value === "home") {
      return row.home_won;
    } else {
      return row.away_won;
    }
  } else if (field === "draw") {
    if (activeTab.value === "all") {
      return row.draw;
    } else if (activeTab.value === "home") {
      return row.home_draw;
    } else {
      return row.away_draw;
    }
  } else if (field === "loss") {
    if (activeTab.value === "all") {
      return row.loss;
    } else if (activeTab.value === "home") {
      return row.home_loss;
    } else {
      return row.away_loss;
    }
  } else if (field === "goals") {
    if (activeTab.value === "all") {
      return row.goals;
    } else if (activeTab.value === "home") {
      return row.home_goals;
    } else {
      return row.away_goals;
    }
  } else if (field === "goals_against") {
    if (activeTab.value === "all") {
      return row.goals_against;
    } else if (activeTab.value === "home") {
      return row.home_goals_against;
    } else {
      return row.away_goals_against;
    }
  } else if (field === "goal_diff") {
    if (activeTab.value === "all") {
      return row.goal_diff;
    } else if (activeTab.value === "home") {
      return row.home_goal_diff;
    } else {
      return row.away_goal_diff;
    }
  } else if (field === "points") {
    if (activeTab.value === "all") {
      return row.points;
    } else if (activeTab.value === "home") {
      return row.home_points;
    } else {
      return row.away_points;
    }
  }
};

const getRecentTitle = (recent: IRecent) => {
  return `${recent.home_scores[0]}:${recent.away_scores[0]} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};
</script>

<script lang="ts">
export default {};
</script>
